import _ from "lodash";

/**
 * Helper to generate list of graphMetrics that only contains data
 *
 * @param list list of objects with any shape
 * @param omitKeys any keys one wishes to omit, eg "date"
 * @returns Array<{ dataKey: string }>
 *
 * Example:
 *
 * In:
 * ```
 * list = [
 *   { date: Date, manual: number, list: number },
 *   { date: Date, manual: number, schedule: number },
 *   { date: Date, manual: number, prediction: number },
 *   { date: Date, schedule: number },
 * ]
 * omitKeys = [ "date" ]
 * ```
 *
 * Out:
 * ```
 * [
 *   { dataKey: "manual" },
 *   { dataKey: "list" },
 *   { dataKey: "schedule" },
 *   { dataKey: "prediction" },
 * ]
 * ```
 */
const getGraphMetrics = (list: object[], omitKeys?: string[]): Array<{ dataKey: string }> => {
  const allExistingKeys: string[] = [];
  // toolTipHeader is a property used by our <GraphToolTip />, accessible by recharts <Tooltip /> payload property
  const keysToOmit = [ "toolTipHeader", ...omitKeys || [] ];
  let keysThatExistInData: string[] = [];

  list.forEach(item => {
    allExistingKeys.push(...Object.keys(item));
  });

  const uniqueKeys = _.uniq(allExistingKeys);

  keysThatExistInData = _.filter(uniqueKeys, (key: string) => !keysToOmit.includes(key));

  return keysThatExistInData.map(existingKey => ({ dataKey: existingKey }));
};

export default getGraphMetrics;